import Fragment from "./fragment";
import FragmentDataType from "../enums/fragment-data-type";
import { playerReducer } from "../../../storage/reducers";
import FragmentSummary from "./fragment-summary";
import PatResultType from "../enums/pat-result-type";
import InterceptedByPositionPref from "./position-pref/intercepted-by-position-pref";

export default class PatIntercepted extends Fragment {
    constructor(interceptedBy) {
        super();
        this.result = PatResultType.INTERCEPTED.code;
        this.interceptedBy = interceptedBy;

        this.requiredData = [
            {
                name: "interceptedBy",
                type: FragmentDataType.Player,
                appliesToOpponent: () => true,
                displayName: "Intercepted By",
                title: (team) => `Intercepted By: ${team.teamName}`,
                subtitle: (team) =>
                    `Select a player from ${team.teamName} or enter the roster number`,
                isEditable: true,
                positionPref: (play) =>
                    new InterceptedByPositionPref(play, this).resolve()
            }
        ];
    }

    getPlayers() {
        return [this.interceptedBy];
    }

    summarize(summaryContext, stringifier) {
        const message = `was intercepted by ${stringifier.firstInitial(
            this.interceptedBy
        )}`;

        return new FragmentSummary(message);
    }

    updateSummaryContext(summaryContext) {
        summaryContext.eopPrinted = true;
    }

    toJSON() {
        return {
            ...super.toJSON(),
            interceptedBy: playerReducer(this.interceptedBy)
        };
    }
}
